import ForgetPwd from "Components/Pages/Auth/ForgetPwd";
import Login from "Components/Pages/Auth/Login";
import RegisterFrom from "Components/Pages/Auth/RegisterFrom";
import ComingBgImg from "Components/Pages/ComingSoon/ComingBgImg";
import AuthLayout from "Layout/AuthLayout";
import AppLayout from "Layout/Layout";
import { PhanQuyenPage } from "pages/phan-quyen/PhanQuyenPage";
import { NonIndexRouteObject } from "react-router";

const authRouters: NonIndexRouteObject[] = [
  {
    path: "/login",
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },
  {
    path: "/forgot-pwd",
    element: (
      <AuthLayout>
        <ForgetPwd logoClassMain="" />
      </AuthLayout>
    ),
  },
  {
    path: "/create-acc",
    element: (
      <AuthLayout>
        <RegisterFrom logoClassMain="" />
      </AuthLayout>
    ),
  },
  {
    path: "/phan-quyen",
    element: (
      <AppLayout>
        <PhanQuyenPage />
      </AppLayout>
    ),
  },

  { path: "*", element: <ComingBgImg /> },
];

export default authRouters;
